'use strict';

/**
 * Component to display a confirm dialog inline with other text. Includes all ARIA roles for accessibility.
 * @param dialogText  The text for all the buttons and labels
 * @param confirmAction A function that does something.
 * @param undoAction A function that undoes confirmAction.
 * @param includeConfirm Boolean that adds an extra confirmation before calling confirmAction.
 *
 * Example Text:
 * const dialogText = {
 *   init: `What does confirmAction do?`,
 *   confirm: `Yea, do it.`,
 *   dismiss: `Nevermind, don't do it.`,
 *   undo: `Oops, undo it.`,
 * }
 */

(function () {
  'use strict';

  angular.module('msCore').component('msInlineDialog', {
    bindings: {
      dialogText: '<',
      confirmAction: '&',
      undoAction: '&',
      includeConfirm: '<'
    },
    templateUrl: 'core/templates/ms-inline-dialog.html',
    controller: MsInlineDialogController
  });

  MsInlineDialogController.$inject = ['$scope', '$log'];

  function MsInlineDialogController($scope, $log) {
    var vm = this;
    vm.success = false;
    vm.toggleConfirmMode = toggleConfirmMode;
    vm.confirm = confirm;
    vm.undo = undo;
    vm.componentId = $scope.$id;

    function toggleConfirmMode() {
      if (vm.includeConfirm) {
        vm.confirmMode = !vm.confirmMode;
      } else {
        confirm();
      }
    }

    function confirm() {
      if (!_.isFunction(vm.confirmAction)) {
        $log.warn('msInlineDialog: confirmAction not bound to function. Check your bindings!');
        return;
      }
      vm.confirmAction().then(function () {
        vm.confirmMode = false;
        vm.success = true;
      });
    }

    function undo() {
      if (!_.isFunction(vm.undoAction)) {
        $log.warn('msInlineDialog: undoAction not bound to function. Check your bindings!');
        return;
      }
      vm.undoAction().then(function () {
        vm.confirmMode = false;
        vm.success = false;
      });
    }
  }
})();